import React, { useContext } from 'react';
import styles from './styles.module.css';
import { ShopContext } from '../../../contexts/ShopContext';
import { ROUTES } from '../../../const';
import { useHistory } from 'react-router-dom';

function SanoftContact() {
  const { shop } = useContext(ShopContext);
  const history = useHistory();

  return (
    <div className={styles.container}>
      <h1 calssName={styles.head}>{shop.name}</h1>
      <button onClick={() => history.push(ROUTES.PIVACY_POLICY.replace(':shopId', shop.shopId))}>Privacy Policy</button>
      <button onClick={() => history.push(ROUTES.TERMS_AND_CONDITIONS.replace(':shopId', shop.shopId))}>Terms & Conditions</button>
      <button onClick={() => history.push(ROUTES.REFUND_POLICY.replace(':shopId', shop.shopId))}>Refund Policy</button>
      <button onClick={() => history.push(ROUTES.SHIPPING_POLICY.replace(':shopId', shop.shopId))}>
        Shipping Policy
      </button>
    </div>
  );
}

export default SanoftContact;
